var map = {
	"./1.jpg": "7L2l",
	"./10.jpg": "AVGG",
	"./11.jpg": "YFws",
	"./12.jpg": "OIgu",
	"./13.jpg": "7iY8",
	"./14.jpg": "7eN9",
	"./2.jpg": "dpEH",
	"./3.jpg": "BEq9",
	"./4.jpg": "vN64",
	"./5.jpg": "Azav",
	"./6.jpg": "bvVD",
	"./7.jpg": "vdh7",
	"./8.jpg": "D1Xz",
	"./9.jpg": "Fr5f"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uzwD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery ^\.\/.*\.jpg$
// module id = uzwD
// module chunks = 1